(function(){
"use strict";
var GROUPS={"0-3m":[0,3,"0-3 months"],"3-12m":[3,12,"3-12 months"],"1-2y":[12,24,"1-2 years"],"2-4y":[24,48,"2-4 years"],"4-6y":[48,72,"4-6 years"],"6-8y":[72,96,"6-8 years"],"8-14y":[96,168,"8-14 years"]};
var PAGE_SIZE=100,MAX_PAGES=12,CARDS_PER_PAGE=12,cache=new Map();
function parseSize(input){
 var s=String(input||"").toLowerCase().trim().replace(/[–—−]/g,"-").replace(/\s+/g,"").replace(/months?|mos?/g,"m").replace(/years?|yrs?/g,"y");
 if(/^(newborn|new-born|nb)$/.test(s))return [0,3];
 var m=s.match(/^(\d{1,2})-(\d{1,2})(m|y)$/);
 if(m){var mult=m[3]==="y"?12:1;return [Number(m[1])*mult,Number(m[2])*mult];}
 m=s.match(/^(\d{1,2})(m|y)$/);
 if(m){var v=Number(m[1])*(m[2]==="y"?12:1);return [v,v+1];}
 return null;
}
function isInGroup(v,key){
 var band=GROUPS[key];if(!band)return false;
 return [v.option1,v.option2,v.option3].some(function(o){
  var size=parseSize(o);return size && size[0]<band[1] && size[1]>band[0];
 });
}
function isFootwear(p){
 var d=[p.title,p.product_type,Array.isArray(p.tags)?p.tags.join(" "):p.tags].filter(Boolean).join(" ").toLowerCase();
 return /(shoe|shoes|sandal|boot|sneaker|pump|footwear|walker|slipper|loafer)/i.test(d);
}
function matchingVariants(p,group){
 if(!p||!Array.isArray(p.variants)||isFootwear(p))return [];
 return p.variants.filter(function(v){return !!v.available&&isInGroup(v,group)});
}
function ttColorOptionIndex(p,matched){
 var list=Array.isArray(p.options)?p.options:[];
 var found=list.findIndex(function(x){return /colou?r|shade|pattern/i.test(typeof x==="string"?x:x&&x.name||"")});
 if(found>=0)return found;
 for(var k=0;k<3;k++){
  var values=(matched||[]).map(function(v){return [v.option1,v.option2,v.option3][k]}).filter(Boolean);
  if(values.some(function(v){return !parseSize(v)&&String(v).toLowerCase()!=="default title"}))return k;
 }
 return -1;
}
function ttColorCards(p,group){
 var list=matchingVariants(p,group);
 var ix=ttColorOptionIndex(p,list),seen=new Set(),cards=[];
 list.forEach(function(v){
  var color=ix>=0?String([v.option1,v.option2,v.option3][ix]||"").trim():"";
  var key=color.toLowerCase()||"__single__";
  if(seen.has(key))return;seen.add(key);
  var sizes=list.filter(function(x){return ix<0||String([x.option1,x.option2,x.option3][ix]||"").trim().toLowerCase()===key});
  cards.push({p:p,v:v,colour:color,sizes:sizes});
 });
 return cards;
}
function matchingVariant(p,group){
 if(!p||!Array.isArray(p.variants)||isFootwear(p))return null;
 return p.variants.find(function(v){return !!v.available&&isInGroup(v,group)})||null;
}
function requestPage(source,page){
 var key=source+":"+page;if(cache.has(key))return cache.get(key);
 var pending=fetch("/collections/"+encodeURIComponent(source)+"/products.json?limit="+PAGE_SIZE+"&page="+page,{credentials:"same-origin",headers:{"Accept":"application/json"}})
 .then(function(r){if(!r.ok)throw Error("Fetch failed");return r.json()})
 .then(function(r){if(!r||!Array.isArray(r.products))throw Error("Unexpected response");return r.products})
 .catch(function(e){cache.delete(key);throw e});
 cache.set(key,pending);return pending;
}
function image(p,v){
 var src=v.featured_image||(p.image||(p.images||[])[0]);
 return typeof src==="string"?src:src&&src.src||"";
}
function money(raw){var n=Number(raw);return Number.isFinite(n)?"Rs. "+n.toLocaleString("en-PK",{maximumFractionDigits:0}):""}
function makeQuickButton(action,product,variant,onlyOne){
 var quickview=action==="view",soldout=product.available===false||!(product.variants||[]).some(function(v){return !!v.available});
 var klass=quickview?"t4s-pr-quickview":"t4s-pr-addtocart";
 var native=null;
 var link=document.createElement("a");
 link.className="t4s-pr-item-btn "+klass;
 link.href="/products/"+encodeURIComponent(product.handle)+"?variant="+encodeURIComponent(variant.id);
 link.rel="nofollow";
 link.setAttribute("aria-label",quickview?"Quick view "+product.title:soldout?"Sold out":onlyOne?"Add "+product.title+" to cart":"Choose size for "+product.title);
 link.title=quickview?"Quick view":soldout?"Sold out":onlyOne?"Add to cart":"Choose size";
 if(quickview){link.dataset.actionQuickview="";link.dataset.id=product.id;}
 else if(soldout){link.removeAttribute("href");link.classList.add("tt-age-card__soldout");link.setAttribute("aria-disabled","true");}
 else{link.dataset.ttQuickAdd=product.handle;link.dataset.ttVariantId=String(variant.id);}
 var nativeIcon=native&&native.querySelector(".t4s-svg-pr-icon");
 if(nativeIcon)link.appendChild(nativeIcon.cloneNode(true));
 else{
  var icon=document.createElement("span");icon.className="t4s-svg-pr-icon";
  var svg=document.createElementNS("http://www.w3.org/2000/svg","svg");
  svg.setAttribute("viewBox","0 0 24 24");svg.setAttribute("width","19");svg.setAttribute("height","19");
  svg.setAttribute("fill","none");svg.setAttribute("stroke","currentColor");svg.setAttribute("stroke-width","1.7");
  var path=document.createElementNS("http://www.w3.org/2000/svg","path");path.setAttribute("d",quickview?"M2 12c5-8 15-8 20 0-5 8-15 8-20 0Z":"M12 4v16M4 12h16");svg.appendChild(path);
  icon.appendChild(svg);link.appendChild(icon);
 }
 return link;
}
/* Every matching SKU variant gets its own linked card. */
function tile(p,v,group,colour,sizes){
 var href="/products/"+encodeURIComponent(p.handle)+"?variant="+encodeURIComponent(v.id);
 var card=document.createElement("article");card.className="tt-age-card t4s-product t4s-pr-grid";
 card.dataset.ttAgeGroup=group;
 card.dataset.productOptions=JSON.stringify({id:p.id,cusQty:1,available:true,handle:p.handle,isDefault:false,VariantFirstID:v.id,price:Math.round(Number(v.price)*100)});
 var wrapper=document.createElement("div");wrapper.className="t4s-product-wrapper";
 var inner=document.createElement("div");inner.className="t4s-product-inner";
 var a=document.createElement("a");a.className="tt-age-card__image-link";a.href=href;
 a.setAttribute("aria-label","View "+p.title+(v.title?" "+v.title:""));
 var media=document.createElement("div");media.className="tt-age-card__media t4s-product-media";
 var url=image(p,v);
 if(url){var photo=document.createElement("img");photo.src=url.startsWith("//")?"https:"+url:url;photo.loading="lazy";photo.decoding="async";photo.width=360;photo.height=360;photo.alt=p.title+(v.title&&v.title!=="Default Title"?" "+v.title:"");media.append(photo);}
 a.append(media);inner.append(a);
 var actions=document.createElement("div");actions.className="t4s-product-btns";
 var add=makeQuickButton("cart",p,v,(sizes||[]).length===1);
 add.dataset.ttAgeGroup=group;add.dataset.ttVariantId=String(v.id);
 if(colour)add.dataset.ttColorValue=colour;
 if((sizes||[]).length===1)add.dataset.ttDirectAgeVariant=String(v.id);
 add.title="Add selected variant to cart";add.setAttribute("aria-label","Add "+p.title+" "+(v.title||"")+" to cart");actions.append(add);inner.append(actions);
 var info=document.createElement("div");info.className="tt-age-card__info t4s-product-info";
 var h=document.createElement("h3");h.className="t4s-product-title";var hl=document.createElement("a");hl.href=href;hl.textContent=p.title;h.append(hl);
 var cost=document.createElement("div");cost.className="tt-age-card__pricing t4s-product-price";cost.textContent=money(v.price);
 var descriptor=document.createElement("span");descriptor.className="tt-age-card__size";
 var availableSizes=[...new Set((sizes||[]).map(function(x){return [x.option1,x.option2,x.option3].find(function(y){return !!parseSize(y)})||""}).filter(Boolean))];
 descriptor.textContent=(colour?colour+" · ":"")+(availableSizes.length?"Sizes: "+availableSizes.join(", "):"Available now");
 info.append(h,cost,descriptor);wrapper.append(inner,info);card.append(wrapper);return card;
}
function start(root){
 if(root.dataset.ttInitialized==="1")return;root.dataset.ttInitialized="1";
 var buttons=[].slice.call(root.querySelectorAll("[data-age]")),genders=[].slice.call(root.querySelectorAll("[data-age-gender]"));
 var personalize=root.querySelector("[data-age-personalize]");
 var result=root.querySelector("[data-age-results]"),grid=root.querySelector("[data-age-grid]"),title=root.querySelector("[data-age-results-title]"),status=root.querySelector("[data-age-status]"),more=root.querySelector("[data-age-more]"),clear=root.querySelector("[data-age-clear]"),shoes=root.querySelector("[data-age-shoes]");
 if(!grid||!status||!more||!clear||!shoes||!title)return;
 var state={group:null,gender:"all",page:1,items:[],at:0,seen:new Set(),done:false,busy:false,token:0};
 function sync(){
  if(personalize)personalize.hidden=!state.group;
  buttons.forEach(function(b){b.setAttribute("aria-pressed",String(b.dataset.age===state.group))});
  genders.forEach(function(b){b.setAttribute("aria-pressed",String(b.dataset.ageGender===state.gender))});
  var newborn=state.group==="0-3m"||state.group==="3-12m";
  shoes.href=newborn?"/collections/new-born-shoes":"/collections/footwear-1";
  shoes.querySelector("strong").textContent=newborn?"Shop newborn & first-walker shoes":"Shop footwear by size";
 }
 function reset(){
  state.token++;state.page=1;state.items=[];state.at=0;state.seen=new Set();state.done=false;state.busy=false;
  grid.replaceChildren();more.hidden=true;status.textContent="";
 }
 async function load(){
  if(state.busy||(state.done&&state.at>=state.items.length)||!state.group)return;
  state.busy=true;var stamp=state.token,count=0;
  more.hidden=true;more.disabled=true;status.textContent="Finding available styles…";
  try{
   while(stamp===state.token&&count<CARDS_PER_PAGE){
    if(state.at>=state.items.length){
     if(state.done||state.page>MAX_PAGES){state.done=true;break;}
     var source=state.gender==="boys"?(root.dataset.ageBoys||"boys"):state.gender==="girls"?(root.dataset.ageGirls||"girls"):(root.dataset.ageSource||"all");
     var batch=await requestPage(source,state.page++);
     if(stamp!==state.token)return;
     if(batch.length<PAGE_SIZE)state.done=true;
     if(!batch.length)break;
     batch.forEach(function(p){ttColorCards(p,state.group).forEach(function(item){state.items.push(item)})});
    }
    if(state.at>=state.items.length)break;
    var entry=state.items[state.at++];if(!entry)continue;
    var p=entry.p,v=entry.v,key=String(p.id)+":"+String(entry.colour||"").toLowerCase();
    if(!v.available||state.seen.has(key))continue;
    state.seen.add(key);grid.appendChild(tile(p,v,state.group,entry.colour,entry.sizes));count++;
   }
   if(stamp!==state.token)return;
   var size=grid.children.length;
   status.textContent=size?"Showing "+size+" in-stock styles.":"No matching stock found. Try a nearby age or browse all.";
   more.hidden=state.done && state.at>=state.items.length;
   more.textContent="Show more styles";
  }catch(err){
    if(stamp!==state.token)return;
    status.textContent="Products couldn't load. Please try again.";
    more.hidden=false;more.textContent="Try again";
  }finally{if(stamp===state.token){state.busy=false;more.disabled=false;}}
 }
 function refresh(){
  reset();sync();
  if(!state.group){result.hidden=true;return}
  result.hidden=false;title.textContent="Shop "+GROUPS[state.group][2];
  load();
 }
 buttons.forEach(function(b){b.addEventListener("click",function(){state.group=b.dataset.age;refresh();var target=personalize||result;target.scrollIntoView({behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"nearest"});})});
 genders.forEach(function(b){b.addEventListener("click",function(){state.gender=b.dataset.ageGender;refresh();})});
 more.addEventListener("click",load);
 clear.addEventListener("click",function(){state.group=null;refresh();buttons[0].focus()});
 sync();
}
function setup(context){(context||document).querySelectorAll("[data-tt-home]").forEach(start)}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){setup(document)});else setup(document);
document.addEventListener("shopify:section:load",function(e){setup(e.target)});
})();